import PropTypes from "prop-types";
import "./Stepper.scss";

const Stepper = ({ totalSteps = 7, currentStep = 1, furthestStep = 1, onStepClick = null }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  const getStepStatus = (step) => {
    if (step < currentStep || (step !== currentStep && step <= furthestStep)) return "completed";
    if (step === currentStep) return "current";
    return "upcoming";
  };

  const handleStepClick = (step) => {
    if (getStepStatus(step) === "completed" && onStepClick) {
      onStepClick(step);
    }
  };

  const stepWidth = 68;
  const getTrackOffset = () => {
    if (currentStep <= 2) return 0;
    return -(currentStep - 2) * stepWidth;
  };

  return (
    <div className="stepper">
      <div
        className="stepper__track"
        style={{ "--track-offset": `${getTrackOffset()}px` }}
      >
        {steps.map((step, index) => (
          <div key={step} className="stepper__step-wrapper">
            {index > 0 && (
              <div
                className={`stepper__connector stepper__connector--${
                  step <= furthestStep ? "active" : "inactive"
                }`}
              />
            )}

            <div className="stepper__step">
              {getStepStatus(step) === "completed" ? (
                <div
                  className="stepper__circle stepper__circle--completed"
                  role="button"
                  tabIndex={0}
                  onClick={() => handleStepClick(step)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleStepClick(step);
                    }
                  }}
                >
                  {step}
                </div>
              ) : (
                <div
                  className={`stepper__circle stepper__circle--${getStepStatus(step)}`}
                  aria-current={step === currentStep ? "step" : undefined}
                >
                  {step}
                </div>
              )}

              {step === currentStep && (
                <div className="stepper__label">
                  {currentStep === totalSteps ? "Next steps" : `Question ${currentStep}`}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Stepper.propTypes = {
  totalSteps: PropTypes.number,
  currentStep: PropTypes.number,
  furthestStep: PropTypes.number,
  onStepClick: PropTypes.func,
};

export default Stepper;
